import { Button, Menu, MenuItem } from '@mui/material';
import { isEmpty } from 'lodash-es';
import { useState } from 'react';

type Contact = { name: string; email: string };

export interface EmailContactSelectProps {
  contacts?: Contact[];
  onSelect: (contact: Contact) => void;
}

export const EmailContactSelect: React.FC<EmailContactSelectProps> = ({ contacts, onSelect }) => {
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const open = Boolean(anchorEl);
  const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget);
  };
  const handleSelect = (contact: Contact) => {
    setAnchorEl(null);
    onSelect(contact);
  };

  return (
    <div>
      <Button
        id="basic-button"
        variant="text"
        aria-controls={open ? 'basic-menu' : undefined}
        aria-haspopup="true"
        aria-expanded={open ? 'true' : undefined}
        onClick={handleClick}
      >
        Add
      </Button>
      <Menu
        id="basic-menu"
        anchorEl={anchorEl}
        open={open}
        onClose={() => setAnchorEl(null)}
        MenuListProps={{
          'aria-labelledby': 'basic-button'
        }}
      >
        {isEmpty(contacts) && <MenuItem onClick={() => setAnchorEl(null)}>No Contact</MenuItem>}
        {contacts?.map((it) => (
          <MenuItem key={it.email} onClick={() => handleSelect(it)}>
            {it.email} - {it.name}
          </MenuItem>
        ))}
      </Menu>
    </div>
  );
};
